var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BlankSpace",style:({height: _vm.currentHeight})})
}
var staticRenderFns = []

export { render, staticRenderFns }